import { render, staticRenderFns } from "./planCompost.html?vue&type=template&id=603420b2&scoped=true&"
import script from "./planCompost.js?vue&type=script&lang=js&"
export * from "./planCompost.js?vue&type=script&lang=js&"
import style0 from "./planCompost.scss?vue&type=style&index=0&id=603420b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603420b2",
  null
  
)

export default component.exports